import DefaultImage from "assets/images/placeholder/product.png";

export const apiVersion = "/api/v1";

export class AppRoutes {
  static LOGIN = "/login";
  static SIGNUP = "/signup";
  static DASHBOARD = "/dashboard";
  static COMPANY_PROFILE = "/company_profile";
  static SETTINGS = "/settings";
  static HOME = "/";
  static _401 = "/401";
  static _404 = "*";
  static BRANCHES = "/branches";
  static CREATE_BRANCH = "/create-branch";
  static EDIT_BRANCH = "/edit-branch";
  static BRANCH_ANALYTICS = "/branch-analytics";
  static CATEGORIES = "/categories";
  static CREATE_CATEGORY = "/create-category";
  static EDIT_CATEGORY = "/edit-category";
  static LOGS = "/logs";
  static ORDERS = "/orders";
  static PRODUCT_TRANSFERS = "/product_transfers";
  static ADD_PRODUCT_TRANSFER = "/add_product_transfer";
  static EDIT_PRODUCT_TRANSFER = "/edit-product-transfer/:id";
  static VIEW_PRODUCT_TRANSFER = "/view-product-transfer/:id";
  static WEIGHBILLS = "/weigh-bills";
  static CREATE_WEIGHBILL = "/create-weigh-bill";
  static EDIT_WEIGHBILL = "/edit-weigh-bill/:id";
  static VIEW_WEIGHBILL = "/view-weigh-bill/:id";
  static EXPENSES = "/expenses";
  static CREATE_EXPENSE = "/create-expense";
  static EDIT_EXPENSE = "/edit-expense/:id";
  static CUSTOMERS = "/customers";
  static PRODUCTS = "/products";
  static CREATE_PRODUCT = "/new-product";
  static SUPPLIERS = "/suppliers";
  static CREATE_SUPPLIER = "/create-supplier";
  static EDIT_SUPPLIER = "/edit-supplier/:id";
  static SUPPLIER_DETAIL = "/supplier-detail/:id";
  static ACCOUNTS = "/accounts";
  static ADD_ACCOUNT = "/create-account";
  static EDIT_ACCOUNT = "/edit-account/:id";
  static VIEW_ACCOUNT = "/view-account/:id";
}

export class ServiceEndpoints {
  // auth
  static LOGIN = apiVersion + "/login";
  static REFRESH = apiVersion + "/refresh";
  static REGISTER = apiVersion + "/register";

  // static FORGOT_PASSWORD = apiVersion + "/forgot-password";
  static FORGOT_PASSWORD = apiVersion + "/password/forgot";
  static RESET_PASSWORD = apiVersion + "/reset-password";
  static CHANGE_PASSWORD = apiVersion + "/change-password";

  // company
  static UPDATE_COMPANY_PROFILE = "/company-profile/create";
  static GET_COMPANY_PROFILE = "/company-profile";

  // organization
  static ORGANIZATIONS = apiVersion + "/organizations";
  static ORGANIZATION = apiVersion + "/organization";
  static CREATE_ORGANIZATION = apiVersion + "/organization";

  // branches
  static BRANCHES = apiVersion + "/branches";
  static BRANCHES_SUMMARY = apiVersion + "/branches-summary";

  // categories
  static CATEGORY = apiVersion + "/categories";

  // suppliers
  static SUPPLIERS = apiVersion + "/suppliers";

  // suppliers
  static CUSTOMERS = apiVersion + "/customers";

  // products
  static PRODUCT = apiVersion + "/products";
  static BULK_PRODUCT = apiVersion + "/bulk-products";

  // logs
  static LOGS = "/log";

  // orders
  static ORDERS = apiVersion + "/orders";

  // product transfer
  static PRODUCT_TRANSFER = apiVersion + "/product_transfers";

  static LOGOUT = apiVersion + "/logout";

  //payment
  static PAYMENT = apiVersion + "/payment_methods";

  // weighbill
  static WEIGHBILL = apiVersion + "/weighbills";

  //expenses
  static EXPENSES = apiVersion + "/expenses";

  //expense-category
  static EXPENSE_CATEGORY = apiVersion + "/expense-category";

  //accounts
  static ACCOUNTS = apiVersion + "/accounts";

  // staff
  static STAFF = apiVersion + "/staff";

  // roles
  static ROLES = apiVersion + "/roles/";
}

export const queryKeys = {
  categories: "catgories",
  branches: "branches",
  suppliers: "suppliers",
  products: "products",
  customers: "customers",
  orders: "orders",
  organizations: "organizations",
  productTransfer: "productTransfer",
  payments: "payments",
  weighbill: "weighbill",
  expenses: "expenses",
  branchesSummary: "branchesSummary",
  accounts: "accounts",
  expenseCategories: "expenseCategories",
  staff: "staff",
  roles: "roles",
};

export const currencies = [
  { label: "GHS", value: "GHS" },
  { label: "USD", value: "USD" },
  { label: "EUR", value: "EUR" },
  { label: "GBP", value: "GBP" },
  { label: "NGN", value: "NGN" },
  { label: "CAD", value: "CAD" },
  { label: "AUD", value: "AUD" },
  { label: "JPY", value: "JPY" },
];

export const features = [
  { name: "accounts" },
  { name: "branches" },
  { name: "categories" },
  { name: "customers" },
  { name: "expenses" },
  { name: "orders" },
  { name: "payments" },
  { name: "products" },
  { name: "reports" },
  { name: "roles" },
  { name: "suppliers" },
  { name: "transfers" },
  { name: "users" },
  { name: "weighbills" },
];

export const APP_NAME = process.env.APP_NAME || "Pappermap";

export const IMAGES = {
  DEFAULT_IMAGE: DefaultImage,
};
